import * as React from 'react';
import { imageBaseURL } from '../../common/constants/CommonConstants';
import PropTypes from 'prop-types';
import { PriceSection } from '../../common/components/PriceSection';

// For Lazy Loading
import { LazyLoadImage } from 'react-lazy-load-image-component';

export class TwoUpSection extends React.Component {

    constructor(props, state) {
        super(props, state);

        this.state = {
            typesWithPriceError: {}
        };

        this.checkTypeForPricingError = this.checkTypeForPricingError.bind(this);
    }

    // This method gets the type from PriceSection component and set the value for provided type to 'true' in calendarTypesWithPriceError state.
    // calendarTypesWithPriceError state is used to apply special css or other treatments to calendar types with no price.
    checkTypeForPricingError(type) {
        const currentTypesWithPricingError = this.state.typesWithPriceError;

        if(!currentTypesWithPricingError[type]) {
            currentTypesWithPricingError[type] = true;

            this.setState({
                typesWithPriceError: currentTypesWithPricingError
            });
        }
    }

    renderDescription(content) {
        return (
            <div className={'description'}>
                <div className={'image-section'}>
                    <picture><LazyLoadImage alt={content.altText || ''} src={imageBaseURL + content.imageURL} /></picture>
                </div>
                <div className={'desc-notes-section'} id={`desc-notes-section-${content.id}`}>
                    {this.renderDescNotes(content.descNotes)}
                </div>
                <div className={`cta-section${this.state.typesWithPriceError[content.id] ? ' no-price' : ''}`}>
                    {this.renderCTASection(content)}
                    {this.props.pricingDetails && this.props.pricingDetails.length > 0 ?
                        <PriceSection contentId={content.id} pricingDetails={this.props.pricingDetails} checkForError={this.checkTypeForPricingError} /> :
                        null
                    }
                </div>
            </div>
        );
    }

    renderDescNotes(descNotes) {
        if(!descNotes) return null;

        return (
            <ul className={'desc-notes'}>
                {
                    descNotes.map((note, index) => <li key={index}>{note}</li>)
                }
            </ul>
        );
    }

    renderCTASection(content) {
        if(!content.ctaLink && content.ctaLink === '') return null;

        let classNames = '';
        const desktopOnly = content.desktopOnlyText && content.desktopOnlyText !== '';

        const ariaDescribedby = `2upsection-heading-${content.id} 2upsection-sub-heading-${content.id} desc-notes-section-${content.id} price-section-${content.id}`;

        if(content.isCTAButton) {
            classNames = 'uig-button uig-primary-button';
        }

        return(
            <div className={content.isCTAButton ? 'btn' : 'cta-link'}>
                <a href={content.ctaLink} className={classNames + (desktopOnly ? ' hide-on-mobile' : '')} aria-describedby={ariaDescribedby}>
                    {content.ctaLinkLable}
                </a>
                {
                    desktopOnly ? <a className="desktop-creation-text hide-on-desktop" aria-describedby={ariaDescribedby}>{content.desktopOnlyText}</a> : null
                }
            </div>
        );
    }

    render() {
        return (
            <div className={'two-up-section'}>
                {
                    this.props.twoUpSectionData.map((content, index) => (
                        <div id={content.id} key={`content-${index}`} className={`content-${index}`}>
                            <h2 className={'section-heading'} id={`2upsection-heading-${content.id}`}>
                                {content.isNew ? <span className={'new-badge'}>NEW </span> : null}
                                {content.heading}
                            </h2>
                            {content.subHeading && content.subHeading !== '' ? <div className={'section-sub-heading'} id={`2upsection-sub-heading-${content.id}`}>{content.subHeading}</div> : null}
                            {this.renderDescription(content)}
                        </div>
                    ))
                }
            </div>
        );
    }

}

TwoUpSection.propTypes = {
    twoUpSectionData: PropTypes.array.isRequired,
    pricingDetails: PropTypes.array
};

TwoUpSection.defaultProps = {
    pricingDetails: []
};
